// extracted by mini-css-extract-plugin
export default {"threePointDiv":"styles_threePointDiv__86RHQ","threePointDivInner":"styles_threePointDivInner__QD+f5"};